import './App.scss'
import React, { useState } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import StepWizard from 'react-step-wizard'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Select from 'react-select'
import countryList from 'react-select-country-list'
import logo from './kcard_logo.png'

function Step1 (props) {
  return (
    <div>
      <h1>Simple... Get Your KCard</h1>
      <h3>Order your kcard in less than 6 minutes.</h3>
      <Button onClick={props.nextStep}>Let's go</Button>
    </div>
  )
}

function Step2 (props) {
  return (
    <div>
      <h1>Personal Informations</h1>
      <h3>To get started, we need some information.</h3>
      <Form.Row>
        <Form.Group as={Col} controlId="firstName">
          <Form.Label>First name</Form.Label>
          <Form.Control type="text" placeholder="First name"/>
        </Form.Group>

        <Form.Group as={Col} controlId="lastName">
          <Form.Label>Last name</Form.Label>
          <Form.Control type="text" placeholder="Last name"/>
        </Form.Group>
      </Form.Row>

      <Form.Group controlId="email">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" placeholder="Enter email"/>
      </Form.Group>


      <h4>Date of Birth</h4>
      <Form.Row>
        <Form.Group as={Col} controlId="birthDay">
          <Form.Label>Day</Form.Label>
          <Form.Control type="text" placeholder="Day"/>
        </Form.Group>

        <Form.Group as={Col} controlId="birthMonth">
          <Form.Label>Month</Form.Label>
          <Form.Control type="text" placeholder="Month"/>
        </Form.Group>

        <Form.Group as={Col} controlId="birthYear">
          <Form.Label>Year</Form.Label>
          <Form.Control type="text" placeholder="Year"/>
        </Form.Group>
      </Form.Row>

      <Button onClick={props.previousStep} variant={'link'}>Back</Button>{' '}
      <Button onClick={props.nextStep}>Continue</Button>
    </div>
  )
}

function Step3 (props) {
  const [phoneNumber, setPhoneNumber] = useState()

  return (
    <div>
      <h1>Phone Number</h1>
      <h5>We'll use it later to sync your phone to your account, so you can use it safely.</h5>

      <Form.Group controlId="email">
        <Form.Label>Phone number</Form.Label>
        <PhoneInput
          placeholder="Phone number"
          value={phoneNumber}
          onChange={setPhoneNumber}/>
      </Form.Group>

      <Button onClick={props.previousStep} variant={'link'}>Back</Button>{' '}
      <Button onClick={props.nextStep}>Continue</Button>
    </div>
  )
}

function Step4 (props) {
  const [countries] = useState(countryList().getData())
  const [country, setCountry] = useState()

  return (
    <div>
      <h1>Legal address</h1>
      <Form.Row>
        <Form.Group as={Col} controlId="streetNumber">
          <Form.Label>Street number</Form.Label>
          <Form.Control type="number" placeholder="Street number"/>
        </Form.Group>

        <Form.Group as={Col} xs={8} controlId="street">
          <Form.Label>Street</Form.Label>
          <Form.Control type="text" placeholder="Street"/>
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} controlId="zipCode">
          <Form.Label>Zip Code</Form.Label>
          <Form.Control type="text" placeholder="Zip code"/>
        </Form.Group>

        <Form.Group controlId="City">
          <Form.Label>City</Form.Label>
          <Form.Control type="text" placeholder="City"/>
        </Form.Group>

        <Form.Group as={Col} controlId="country">
          <Form.Label>Country</Form.Label>
          <Select
            name={'country'}
            placeholder={'Country'}
            value={country}
            onChange={setCountry}
            options={countries}
          />
        </Form.Group>
      </Form.Row>

      <Button onClick={props.previousStep} variant={'link'}>Back</Button>{' '}
      <Button onClick={props.nextStep}>Continue</Button>
    </div>
  )
}

function Step5 (props) {
  const [countries] = useState(countryList().getData())
  const [nationality, setNationality] = useState()
  const [nativeCountry, setNativeCountry] = useState()

  return (
    <div>
      <h1>Further information</h1>
      <h5>Please tell us what is your nationality and place of birth.</h5>
      <Form.Group controlId="nationality">
        <Form.Label>Nationality</Form.Label>
        <Select
          name={'nationality'}
          placeholder={'Nationality'}
          value={nationality}
          onChange={setNationality}
          options={countries}
        />
        <Form.Text className="text-muted">
          As it is written on your ID.
        </Form.Text>
      </Form.Group>
      <Form.Row>
        <Form.Group as={Col} controlId="cityOfBirth">
          <Form.Label>City of birth</Form.Label>
          <Form.Control type="text" placeholder="City of birth"/>
        </Form.Group>

        <Form.Group as={Col} controlId="nativeCountry">
          <Form.Label>Native country</Form.Label>
          <Select
            name={'nativeCountry'}
            placeholder={'Native country'}
            value={nativeCountry}
            onChange={setNativeCountry}
            options={countries}
          />
        </Form.Group>
      </Form.Row>

      <h5>What is your gender?</h5>
      <p>For legal reasons, you can only select one of these two options.</p>
      <Form.Row>
        <Form.Group as={Col}>
          <div className={'radio-input-container'}>
            <Form.Check inline name={'gender'} value={'female'} label="Female" type={'radio'}
                        id={`inline-radio-female`}/>
          </div>
        </Form.Group>
        <Form.Group as={Col}>
          <div className={'radio-input-container'}>
            <Form.Check inline name={'gender'} value={'male'} label="Male" type={'radio'} id={`inline-radio-male`}/>
          </div>
        </Form.Group>
      </Form.Row>

      <h5>Upload your ID</h5>

      <Form.Group>
        <Form.File
          id="custom-file"
          label="Upload your ID"
          custom
        />
      </Form.Group>

      <Button onClick={props.previousStep} variant={'link'}>Back</Button>{' '}
      <Button onClick={props.nextStep}>Continue</Button>
    </div>
  )
}

function Step6 (props) {
  return (
    <div>
      <h1>Open account</h1>
      <h5>To open your Kcard account, please accept the General Conditions of Use.</h5>
      <Form.Group controlId="nationality">
        <Form.Check inline name={'CGU'} value={'CGU'} label="Term and condition" type={'checkbox'} id={`cgu-checkbox`}/>
        <Form.Text className="text-muted">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, assumenda commodi eius enim esse
          excepturi, facilis harum nisi odio, odit placeat quam quos sed sint sunt temporibus ullam unde veritatis!
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="nationality">
        <Form.Check inline name={'CGU'} value={'CGU'} label="Lorem ipsum dolor" type={'checkbox'} id={`cgu-checkbox`}/>
        <Form.Text className="text-muted">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, assumenda commodi eius enim esse
          excepturi, facilis harum nisi odio, odit placeat quam quos sed sint sunt temporibus ullam unde veritatis!
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="nationality">
        <Form.Check inline name={'CGU'} value={'CGU'} label="Lorem ipsum dolor" type={'checkbox'} id={`cgu-checkbox`}/>
        <Form.Text className="text-muted">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, assumenda commodi eius enim esse
          excepturi, facilis harum nisi odio, odit placeat quam quos sed sint sunt temporibus ullam unde veritatis!
        </Form.Text>
      </Form.Group>

      <Form.Group controlId="nationality">
        <Form.Check inline name={'CGU'} value={'CGU'} label="Lorem ipsum dolor" type={'checkbox'} id={`cgu-checkbox`}/>
        <Form.Text className="text-muted">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, assumenda commodi eius enim esse
          excepturi, facilis harum nisi odio, odit placeat quam quos sed sint sunt temporibus ullam unde veritatis!
        </Form.Text>
      </Form.Group>

      <Button onClick={props.previousStep} variant={'link'}>Back</Button>{' '}
      <Button onClick={props.nextStep}>Continue</Button>
    </div>
  )
}

function App () {
  const [currentStep, setCurrentStep] = useState(1)

  const menuItems = [
    { label: 'Personal Informations' },
    { label: 'Phone Number' },
    { label: 'Legal address' },
    { label: 'Further information' },
    { label: 'Open account' }
  ]

  const renderMenuItem = ({ label }, index) => {
    const step = index + 2
    // Adapt color if already pass or if current step
    const textColor = step === currentStep
      ? 'font-weight-bold'
      : step < currentStep
        ? 'text-primary'
        : null
    return (
      <Row key={index}>
        <h6 className={textColor}>{label}</h6>
      </Row>
    )
  }

  console.log('currentStep', currentStep)

  return (
    <div className="App">
      <Container fluid className={'d-flex flex-column'}>
        <Row className={'d-flex d-lg-none justify-content-center'}>
          <a href="http://kcard.fr">
            <img src={logo} alt="logo" className={'Logo-mobile'}/>
          </a>
        </Row>
        <Row style={{ flex: 1 }}>
          <Col className={'Sidebar d-none d-lg-flex'} sm={4} md={3} xl={2}>
            <a href="http://kcard.fr">
              <img src={logo} alt="logo" className={'Logo'}/>
            </a>
            <Row>
              <Col>
                {menuItems.map((item, index) => renderMenuItem(item, index))}
              </Col>
            </Row>
          </Col>
          <Col md={{ span: 6, offset: 1 }} sm={8} className={'MainContainer'}>
            <Form>
              <StepWizard
                onStepChange={({ activeStep }) => {
                  setCurrentStep(activeStep)
                }}>
                <Step1/>
                <Step2/>
                <Step3/>
                <Step4/>
                <Step5/>
                <Step6/>
              </StepWizard>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default App
